import styled from 'styled-components'
import { GREY_NORMAL_COLOR, GREY_LIGHT_COLOR } from '@CSSVars/colors'

export const _IconWithValue = styled.div`
  transition: all .5s;
  flex: 0 1 auto;
  padding-left: 0.25rem;
  display: flex;
  align-items: center;

`
export const _PreviewIcon = styled.div`
  display: block;
  font-size: 0;
  svg{
    transition: fill 0.5s;
    fill: ${GREY_NORMAL_COLOR};
  }


`
export const _PreviewCopy = styled.div`
  color: ${GREY_LIGHT_COLOR};
  font-size: 12px;
  font-weight: 400;
  vertical-align: top;
  padding-left: 0.25rem;

`
